import React, { useState, useEffect } from 'react';
import IconButton from '@fuww/library/src/Button/IconButton';
import Snackbar, { SnackbarContent } from '@fuww/library/src/Snackbar';
import Alert from '@fuww/library/src/Alert';
import ClearIcon from '@fuww/library/src/Icons/Clear';
import { useIntl } from 'react-intl';
import ClearSiteDataButton from '../../ClearSiteDataButton';
import messages from '../../lib/messages';

interface ErrorSnackbarProperties {
  autoHideDuration?: number;
}

const ErrorSnackbar = ({
  autoHideDuration = 10_000,
}: ErrorSnackbarProperties) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const intl = useIntl();

  const displaySnackbar = (event: CustomEvent<string>) => {
    const errorMessage = event.detail;
    setMessage(errorMessage);
    setOpen(true);
  };

  useEffect(() => {
    window.addEventListener(
      'displaySnackbar', displaySnackbar as EventListener,
    );
    return () => {
      window.removeEventListener(
        'displaySnackbar', displaySnackbar as EventListener,
      );
    };
  }, []);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={() => setOpen(false)}
      autoHideDuration={autoHideDuration}
    >
      <Alert
        elevation={6}
        variant="filled"
        severity="error"
        action={(
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              setOpen(false);
            }}
          >
            <ClearIcon fill="#fff" />
          </IconButton>
        )}
      >
        <SnackbarContent>
          {message}
          <div>
            <ClearSiteDataButton
              buttonLabel={intl.formatMessage(messages.reset)}
            />
          </div>
        </SnackbarContent>
      </Alert>
    </Snackbar>
  );
};

export default ErrorSnackbar;
